
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelCube as ObiBuoyBarrelCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-cube.js';
 
 
 

 
 export const ObiBuoyBarrelCube = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-cube',
   elementClass: ObiBuoyBarrelCubeElement,
   events: {
     
   }
  });
 
 